export class UnauthorizedException {
  constructor(public message: string = 'Unauthorized exception') {}
}
